import { createInterpreterOfferAlert } from '../../../interpreter-offer-alert';
const alertApi = typeof window === 'undefined'
    ? null
    : createInterpreterOfferAlert(window);
export function prepareInterpreterOfferAlerts() {
    return alertApi?.prepare() || Promise.resolve('unsupported');
}
export function startInterpreterOfferAlert(request) {
    return alertApi?.start(request) || (() => undefined);
}
